import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { PlatformEntitiesResponseSchema } from '../shared/schemas/platformEntities.js';

export type {
  PlatformEntityItemType,
  PlatformEntitiesResponseType,
  DevicePlatform,
} from '../shared/schemas/platformEntities.js';

export const getPlatformEntities = defaultClient.query({
  url: 'omni-trafficking/v1/external-data/platform-entities/',
  method: 'GET',
  responseSchema: PlatformEntitiesResponseSchema,
  processResponse(data) {
    return data?.data?.items;
  },
  querySchema: z.object({
    integrationId: z.string(),
    externalActivityEntityId: z.string().array().nullable(),
  }),
  snakeCaseQueryParams: true,
});
